<template>
  <div class="desktop-datails">
    <div class="cl-black">
      <div class="button">
        <p class="accord-button uppercase flex center-xs px8 py10 lh20 fs15 relative letter-space weight-500 m0" @click="toogleDescription()">
          <template class="title" v-if="showDescription">
            {{ title }} <i class="material-icons close-footer-icon icon-MINUS" />
          </template>
          <template class="title" v-else>
            {{ title }}  <i class="material-icons open-footer-icon icon-PLUS" />
          </template>
        </p>
      </div>
      <div v-show="showDescription" class="product-description relative flex row m0 px15 pb10" v-html="description" />
    </div>
  </div>
</template>

<script>
import getLabelMixin from 'theme/mixins/getLabelMixin.ts'
import { mapGetters } from 'vuex'
import LazyHydrate from 'vue-lazy-hydration'
import { registerModule } from '@vue-storefront/core/lib/modules'
import { onlineHelper } from '@vue-storefront/core/helpers'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedTab: 1,
      detailsOpen: false,
      showDescription: false,
      showRewiew: false
    }
  },
  components: {
    LazyHydrate
  },
  mixins: [getLabelMixin],
  methods: {
    getLabelFor (type) {
      if (this.listByCode && this.listByCode[type]) {
        let items = this.listByCode[type].options.filter((option) => { return option.value === String(this.prod[type]) })
        if (items && items.length) {
          return items[0].label
        } else {
          return false
        }
      }
    },
    getLabelforValue (type, value) {
      if (!(this.listByCode && this.listByCode[type])) return null
      // add mapped attribute to store if not added before
      if (!Object.keys(this.mappedAttributes).includes(type)) {
        this.addAttributeToMap(type)
      }
      return this.mappedAttributes[type][value]
    },
    showDetails (event) {
      this.detailsOpen = true
      event.target.classList.add('hidden')
    },
    updateSelected (tab) {
      this.selectedTab = tab
    },
    updateChildSelected (tab) {
      this.selectedChildTab = tab
    },
    toogleDescription () {
      if (!this.showDescription) {
        this.showDescription = true
      } else {
        this.showDescription = false
      }
    },
    toogleRewiew () {
      if (!this.showRewiew) {
        this.showRewiew = true
      } else {
        this.showRewiew = false
      }
    }
  },
  computed: {
    ...mapGetters({
      getOriginalProduct: 'product/getOriginalProduct',
      getCurrentProduct: 'product/getCurrentProduct'
    }),
    listByCode () {
      return this.$store.state.attribute.list_by_code
    },
    isOnline (value) {
      return onlineHelper.isOnline
    }
  }
}

</script>

<style lang="scss" scoped>
.custom-arrow {
  border: solid black;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  margin-right: 10px;
}
.material-icons {
  font-size: 25px;
    position: absolute;
    right: 5px;
}
.product-description {
  background-color: white;
    font-size: 14px;
    padding-top: 20px;
    padding-bottom: 20px;
    line-height: 2;
}
.desktop-datails {
    background-color: #EFEFEF;
    margin-top: 5px;
    margin-bottom: 5px;
  }
.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.fs16 {
  font-size: 16px;
  line-height: normal;
}
.p30 {
  padding: 30px;
}
.product-materials {
  display: flex;
}
.product-materials:not(:last-child):after {
  content:',';
}
.description {
  @media (max-width: 767px) {
    padding-left: 27px;
  }
}
.shippingIcon {
  width: 50px;
  padding-right: 5px;
  height: 50px;
  object-fit: contain;
}
.tabs {
  .tablist {
    cursor: pointer;
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
    li {
      display: inline-block;
      color: #191919;
      padding: 5px 0px;
      margin-right: 20px;
      font-size: 18px;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      &.current {
        font-weight: 700;
        border-bottom: 2px solid #191919;
      }
    }
  }
}
.accord-button {
  font-weight: 300;
  color: #646464;
}

@media (max-width: 767px) {
  .accord-button {
    display: flex;
    align-items: center;
    margin: 0;
    font-size: 14px;
  }
  .accord-button1 {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 10px 10px;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
}
</style>
